<template>
  <div id="footer" class="container-fluid">
<!--    <div class="logo" style="visibility: hidden">-->
<!--      <img src="@/assets/img/foot/logo.png"  style="width: 100%;height: 100%">-->
<!--    </div>-->
<!--    <div class="detail">-->
<!--      <img src="@/assets/img/foot/title.png" style="width: 100%;height: 100%">-->
<!--    </div>-->
    <div class="logo wow pulse">
      <img src="@/assets/img/foot/foot.png" style="width: 100%;height: 100%">
    </div>
<!--    <p class="title wow pulse">致力于打造第一创业财富平台</p>-->
<!--    <div class="address_tel_fax wow pulse">-->
<!--      <div class="tel-border">-->
<!--        <div class="qgrx" style="">-->
<!--          <div>全国创业</div>-->
<!--          <div>财富热线</div>-->
<!--        </div>-->

<!--        <div style="margin: 5px 15px;padding-left: 10px;float: left;display: flex; border-left: 1px solid rgba(255,255,255,0.9);">-->
<!--          <div style="margin: auto 0;font-weight: 600;">{{hotline}}</div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <div class="bah ">京ICP备2023035168号 <span class="gxb" @click="openHref">工信部</span></div>
  </div>
</template>
<script>
import {contactlatest} from "../api";

export default {
  name: "Footer",
  data() {
    return {
      hotline: '010-57170383',
    }
  },
  created() {
    // debugger
    // this.getContact()
    // window.setTimeout(() => {
    //   this.getContact()
    // }, 10000);
  },
  methods:{
    openHref(){
      window.open( "https://wap.miit.gov.cn/",'_blank')
    },
    getContact(){
      let contactStor = sessionStorage.getItem('contactinfo')
      if(contactStor && contactStor != undefined && contactStor!=null && contactStor !='undefined' && contactStor !='null' ){
        let contactInfo = JSON.parse(contactStor)
        this.hotline = contactInfo.hotline
      } else {
        contactlatest().then(res => {
          if(res.code == '200'){
            this.hotline = res.data.hotline
            sessionStorage.setItem('contactinfo',JSON.stringify(res.data))
          }
        }).catch(error => {

        })
      }
    },
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background-image: url("../assets/img/foot/back.png") ;
  background-size: 100% 100%;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 350px;
  margin: 30px auto 20px;
}
.detail {
  width: 95px;
  margin: 30px auto 20px;
}
.title {
  font-size: 24px;
  margin: 0 0 5px 0 ;
  font-weight: bold;
  color: rgba(255,255,255,0.9);
}
.address_tel_fax {
  /*color: #d3d3d3;*/
  font-size: 28px;
  margin: 10px auto  10px;
  display: flex;
  justify-content: space-around;
}
.bah {
  /*color: #d3d3d3;*/
  cursor: pointer;
  font-size: 16px;
  margin: 30px auto  60px;
  display: flex;
  justify-content: center;
}
.gxb{
  margin-left: 10px;
  color: #3a8ee6
}
.gxb:hover{
  margin-left: 10px;
  color: #3070b4
}
.tel-border{
  border: 1px solid #d3d3d3;
  padding: 3px 12px 1px 30px;
  border-radius: 50px;
  color: rgba(255,255,255,0.9);
}
.qgrx{
  /*color: #d3d3d3;*/
  float: left;font-size: 16px
}
@media screen and (max-width: 997px) {
  .qgrx{
    font-size: 12px
  }
  .logo {
    width: 250px;
    margin: 20px auto 15px;
  }
  .detail {
    width: 45px;
    margin: 10px auto 10px;
  }
  .title {
    font-size: 18px;
    margin: 0 0 4px 0 ;
  }

  .address_tel_fax {
    font-size: 20px;
    margin: 0 auto  10px;
  }
  .bah {
    /*color: #d3d3d3;*/
    font-size: 16px;
    margin: 30px auto  40px;
    display: flex;
    justify-content: center;
  }
}


</style>




// WEBPACK FOOTER //
// src/components/Footer.vue